import { render, staticRenderFns } from "./ProductsFoundersBody.vue?vue&type=template&id=3de45c28&scoped=true&"
import script from "./ProductsFoundersBody.vue?vue&type=script&lang=js&"
export * from "./ProductsFoundersBody.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFoundersBody.vue?vue&type=style&index=0&id=3de45c28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de45c28",
  null
  
)

export default component.exports